class SmsManagementComponentCtrl {
    constructor(SmsManagementApi,
                notificationService,
                DoclrModalService,
                userContext,
                $state,
                snorretjeReplace,
                $rootScope) {
        'ngInject';

        this.SmsManagementApi = SmsManagementApi;
        this.notificationService = notificationService;
        this.DoclrModalService = DoclrModalService;
        this.userContext = userContext;
        this.smsManagement = undefined;
        this.$state = $state;
        this.showOnlyActive = false;
        this.hasActiveConfigurations = false;
        this.snorretjeReplace = snorretjeReplace;
        this.theRootScope = $rootScope;
    }

    $onInit() {
        this.smsManagement = this.SmsManagementApi.getSmsManagement()
            .then(x => this.smsManagement = x)
            .then(() => this.onToggleShowOnlyActive());
    }

    bepaalSmsText(smsAvailabilityTypeConfiguration, smsCalendarConfiguration) {

        const smsPrefix = doclrVertaal.instant('partials.instellingen.sms.afspraaktypes.pre1.sms') + ' ' + moment().format('DD-MM-YYYY') + ' ' + doclrVertaal.instant('partials.instellingen.sms.afspraaktypes.pre2.sms') + ' 13:37. ';


        if (!(this.smsManagement.sendSms && smsAvailabilityTypeConfiguration.sendSms && smsCalendarConfiguration.sendSms) &&
            !(this.smsManagement.sendReminderSms && smsAvailabilityTypeConfiguration.sendReminderSms && smsCalendarConfiguration.sendReminderSms)) {
            return doclrVertaal.instant('partials.instellingen.geen.sms.ingesteld');
        }

        if (smsAvailabilityTypeConfiguration.hasCustomSmsText && smsAvailabilityTypeConfiguration.smsText) {
            return this.getSmsPreview(smsAvailabilityTypeConfiguration.smsText);
        }

        if (smsCalendarConfiguration.hasCustomSmsText && smsCalendarConfiguration.smsText) {
            return this.getSmsPreview(smsCalendarConfiguration.smsText);
        }

        if (this.smsManagement.hasCustomSmsText && this.smsManagement.smsText) {
            return this.getSmsPreview(this.smsManagement.smsText);
        }

        return doclrVertaal.instant('partials.instellingen.geen.sms.text');
    };

    verstuuurdSms(smsAvailabilityTypeConfiguration, smsCalendarConfiguration) {
        let smsTekst = this.bepaalSmsText(smsAvailabilityTypeConfiguration, smsCalendarConfiguration);

        return smsTekst !== doclrVertaal.instant('partials.instellingen.geen.sms.ingesteld') && smsTekst !== doclrVertaal.instant('partials.instellingen.geen.sms.text')
    }

    saveSmsManagement() {
        this.SmsManagementApi.updateSmsManagement(this.smsManagement)
            .then(() => this.notificationService.showSuccess(doclrVertaal.instant('partials.instellingen.sms.wijzig.succes')))
    }

    cancelSmsManagement() {
        this.$state.go('agenda.initial');
    }

    onChangeSendSmsForType(smsAvailabilityTypeConfiguration) {
        const hasCustomSmsText = smsAvailabilityTypeConfiguration.smsText && smsAvailabilityTypeConfiguration.smsText !== ' ';
        smsAvailabilityTypeConfiguration.hasCustomSmsText = hasCustomSmsText;
        this.onToggleShowOnlyActive();
    }

    onChangeSendSmsForCalendar(smsCalendarConfiguration) {
        const hasCustomSmsText = smsCalendarConfiguration.smsText && smsCalendarConfiguration.smsText !== ' ';
        smsCalendarConfiguration.hasCustomSmsText = hasCustomSmsText;
        this.onToggleShowOnlyActive();
    }

    deleteTypeText(smsAvailabilityTypeConfiguration) {
        this.DoclrModalService.openConfirmModal(doclrVertaal.instant('partials.instellingen.sms.verwijder.tekst.type.popup.titel'),
            doclrVertaal.instant('partials.instellingen.sms.verwijder.tekst.type.popup.vraag')
        ).then(() => {
            smsAvailabilityTypeConfiguration.smsText = undefined;
            smsAvailabilityTypeConfiguration.hasCustomSmsText = false;
        }, () => {
        })
    }

    deleteCalendarText(smsCalendarConfiguration) {
        this.DoclrModalService.openConfirmModal(doclrVertaal.instant('partials.instellingen.sms.verwijder.tekst.calendar.popup.titel'),
            doclrVertaal.instant('partials.instellingen.sms.verwijder.tekst.calendar.popup.vraag')
        ).then(() => {
            smsCalendarConfiguration.smsText = undefined;
            smsCalendarConfiguration.hasCustomSmsText = false;
        }, () => {
        })
    }


    changeTypeText(smsAvailabilityTypeConfiguration) {
        let that = this;
        let changeTextModal = {
            smsText: smsAvailabilityTypeConfiguration.smsText,
            getSmsPreview: function (text) {
                return that.getSmsPreview("Herinnering - " + text);
            }
        };

        this.DoclrModalService.openAddModal(
            '/partials/instellingen/sms-management.change.type.text.popup.html',
            {
                model: changeTextModal,
                backdrop: 'static'
            })
            .then(() => {
                const hasCustomSmsText = changeTextModal.smsText && changeTextModal.smsText !== ' ';
                smsAvailabilityTypeConfiguration.smsText = changeTextModal.smsText;
                smsAvailabilityTypeConfiguration.hasCustomSmsText = hasCustomSmsText;
            }, () => {
            });
    }


    getSmsPreview(text) {
        return this.snorretjeReplace(text, {
            date: "17-05-1986",
            time: "13:37",
            product: "Afhalen identiteitskaart"
        })

    }

    changeCalendarText(smsCalendarConfiguration) {

        let that = this;

        let changeTextModal = {
            smsText: smsCalendarConfiguration.smsText,
            getSmsPreview: function (text) {
                return that.getSmsPreview("Herinnering - " + text);
            }
        };

        this.DoclrModalService.openAddModal(
            '/partials/instellingen/sms-management.change.calendar.text.popup.html',
            {
                model: changeTextModal,
                backdrop: 'static'
            })
            .then(() => {
                const hasCustomSmsText = changeTextModal.smsText && changeTextModal.smsText !== ' ';
                smsCalendarConfiguration.smsText = changeTextModal.smsText;
                smsCalendarConfiguration.hasCustomSmsText = hasCustomSmsText;
            }, () => {
            });
    }


    onToggleShowOnlyActive() {
        this.setActiveSmsCalendarConfigurations();
        this.setActiveSmsAvailabilityTypeConfigurations();
        this.hasActiveConfigurations = this.activeSmsCalendarConfigurations.length > 0 && this.activeSmsAvailabilityTypeConfigurations.length > 0;
    }

    setActiveSmsCalendarConfigurations() {
        this.activeSmsCalendarConfigurations = this.smsManagement.smsCalendarConfigurations.filter(x => x.sendSms || !this.showOnlyActive);
    }

    setActiveSmsAvailabilityTypeConfigurations() {
        this.activeSmsAvailabilityTypeConfigurations = this.smsManagement.smsAvailabilityTypeConfigurationList.filter(x => x.sendSms || !this.showOnlyActive);
    }
}

(function () {
    'use strict';

    angular.module('doclr.instellingen')
        .config(function ($stateProvider) {
            $stateProvider
                .state('sms-beheer', {
                    url: '/instellingen/smsbeheer',
                    templateUrl: '/partials/instellingen/sms-management.html',
                    controller: SmsManagementComponentCtrl,
                    controllerAs: 'SmsManagementComponentCtrl'
                })
        });
})();